var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 165H54.9984V109.995H36.6673V165Z",
    fill: "#142533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.666 165H165V73.3387H146.666V165Z",
    fill: "#142533"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 165H18.3311V55.0052H0V165Z",
    fill: "#142533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3293 164.904H91.663V36.581H73.3293V164.904Z",
    fill: "#142533"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 91.6664H54.9984V0.00770936H36.6673V91.6664Z",
    fill: "#FAB80A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.004 165H128.335V91.6664H110.004V165Z",
    fill: "#142533"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.004 73.3387H128.335V0.00770007H110.004V73.3387Z",
    fill: "#FAB80A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.669H18.3311V0.00771595H0V36.669Z",
    fill: "#FAB80A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.666 0V55.0052H165V0H146.666Z",
    fill: "#FAB80A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3293 18.3361H91.663V0.00770499H73.3293V18.3361Z",
    fill: "#FAB80A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/LogoYellow.2708679d4cd956b072b8d86cba34fb18.svg";
export { ForwardRef as ReactComponent };